function reorderWithFilledFields() {
    var wrappers = document.querySelectorAll('.js-reorder-wrapper');
    
    for (var i = 0; i < wrappers.length; i++) {
      var nameData = encodeURI( wrappers[i].querySelector('.js-order-name').innerText );
      var emailData = encodeURI( wrappers[i].querySelector('.js-order-email').innerText );
      var phoneData = encodeURI( wrappers[i].querySelector('.js-order-phone').innerText.replace('+', 'PLUS') );
      var link = wrappers[i].querySelector('.js-reorder-link');
      var linkData = link.getAttribute('href');
      
      link.setAttribute('href', `${linkData}&name=${nameData}&email=${emailData}&phone=${phoneData}`)
    }
  }
  
  reorderWithFilledFields();